import { z } from 'zod';

/////////////////////////////////////////
// PERMITS STEPS SCHEMA
/////////////////////////////////////////

export const PermitsStepsSchema = z.object({
  id: z.bigint(),
  title: z.string().nullable(),
  description: z.string().nullable(),
  permit_id: z.bigint(),
  due_date: z.coerce.date().nullable(),
  assignee_id: z.number().int().nullable(),
  order: z.number().int().nullable(),
  permits_type_step_id: z.number().int().nullable(),
  step_type: z.string().nullable(),
  status: z.string().nullable(),
  status_updated_at: z.coerce.date().nullable(),
  reason: z.string().nullable(),
  note: z.string().nullable(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
  inspections_type_id: z.number().int().nullable(),
  active_inspection_id: z.number().int().nullable(),
  official_permit_document: z.boolean().nullable(),
  skippable: z.boolean().nullable(),
  require_completion_message: z.boolean().nullable(),
  automatic_complete: z.boolean().nullable(),
  original_assignee_id: z.number().int().nullable(),
  completed_user_id: z.bigint().nullable(),
  documents_background_job_id: z.number().int().nullable(),
  rowTimestamp: z.coerce.date(),
})

export type PermitsSteps = z.infer<typeof PermitsStepsSchema>

export default PermitsStepsSchema;
